<template>
  <div class="zhenyun" style="background: #fff; min-height: calc(100vh - 72px)">
    <div class="zhenyun-banner"></div>
    <div class="zhenyun-tab">
      <ul class="ul">
        <li
          v-for="item in tabList"
          :key="item.id"
          :class="activeName == item.id ? 'activeClass' : ''"
          @click="handleClick(item)"
          style="font-family: SourceHanSansCN-Regular"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <!-- 开辟渠道 -->
    <div class="zhenyun-content">
      <div class="content-detail">
        <!-- <p class="content-detail-title">直链国内领先采购数字化平台</p> -->
        <div class="content-detail-msg">
          <div class="line">
            <div class="line-mode" style="height: 178px">
              <div class="mode-tag">
                <span>订单渠道：甄云科技、电气数科、中国航天、中铁工程装备</span>
              </div>
              <div class="mode-method">
                <p>参与条件：海智会员工厂</p>
                <div class="methods">
                  <div style="line-height: 28px; margin-right: 110px">
                    <div class="fontclass">01. 开通平台收款账号</div>
                    <div class="fontclass">03. 确认委托扣款授权书</div>
                  </div>
                  <div style="line-height: 28px">
                    <div class="fontclass">02. 签署居间服务协议</div>
                    <div class="fontclass">04. 报价接单，成交赚钱</div>
                  </div>
                </div>
              </div>
              <div class="btn">
                <img class="img" src="@/assets/image/zhenyun/join.png" alt="" />
                <div class="msg">
                  <i class="el-icon-circle-check"></i> 免费开户 |
                  <i class="el-icon-circle-check"></i> 成交后付费 |
                  <i class="el-icon-circle-check"></i> 接入即获客
                </div>
                <div class="click" @click="joinActive">
                  立即参与
                  <i class="el-icon-right" style="margin-left: 8px"></i>
                </div>
              </div>
            </div>
            <div class="contract-user">
              <p>
                <img
                  src="@/assets/image/zhenyun/star.png"
                  alt=""
                  style="width: 14px"
                />
                <span
                  >解锁海智生态专区千万级订单资源！报名咨询：{{salesInfoClient.name}}
                  {{salesInfoClient.phone}}</span
                >
              </p>
            </div>
            <el-carousel style="width: 480px" height="230px" :interval="3000">
              <el-carousel-item
                v-for="(item, index) in bannerList"
                :key="index"
              >
                <div class="line-channel" style="height: calc(100% - 36px)">
                  <div class="down">
                    <img
                      src="@/assets/image/zhenyun/font-quote.png"
                      alt=""
                      style="height: 19px"
                    />
                  </div>
                  <div class="msg">{{ item.text }}</div>
                  <div class="up">
                    <img
                      src="@/assets/image/zhenyun/back-quote.png"
                      alt=""
                      style="height: 19px"
                    />
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <!-- 最新采购需求 -->
    <div class="zhenyun-content" v-if="rfqList.length > 0">
      <div class="content-detail2">
        <div class="title">
          <p>最新采购需求</p>
          <a @click="goAllRfq" style="cursor: pointer"
            >查看全部<i class="iconfont icon-chevron-right"></i>
          </a>
        </div>
        <div class="demand">
          <div
            class="demand-item"
            v-for="(item, index) in rfqList"
            :key="item.id"
            @click="goRfqDetail(item)"
          >
            <div class="product">
              <div class="product-icon" v-if="item.isEmergency == 1">
                <i class="iconfont icon-jinji"></i>紧急
              </div>
              <div style="width: 120px; height: 120px; margin: 0 auto">
                <img
                  :src="`${partDrawingUrl}${item.partThumbnailsHashCode}`"
                  alt=""
                  :onerror="`this.src='${defaultRfqThn}'`"
                  style="width: 100%; object-fit: contain"
                />
              </div>
              <ul class="product-ul">
                <li style="color: #555" class="productName">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.title"
                    placement="top"
                    :disabled="childTitleWidth <= 235"
                    popper-class="compToolTipClass"
                  >
                    <div
                      class="parentTitleClass"
                      @mouseenter="handleMouseEnter($event, index)"
                    >
                      <span
                        class="childTitleClass"
                        :style="{ color: item.isRead ? '#858585' : '#555' }"
                      >
                        {{ item.title }}
                        <i
                          v-if="item.isCarbonFootprint"
                          class="iconfont icon-tanpaifang"
                          style="color: #18b83e; font-size: 18px"
                        ></i>
                      </span>
                    </div>
                  </el-tooltip>
                </li>
                <li
                  style="color: #222; font-weight: 500"
                  :style="{ color: item.isRead ? '#858585' : '#222' }"
                >
                  {{ item.mainCategoryStr }}｜采购量：{{
                    item.purchaseVolume
                      ? item.purchaseVolume
                      : item.partsNum + '种零件'
                  }}
                </li>
              </ul>

              <div class="tag">
                <span>{{ item.paymentTermsStr }}</span>
              </div>
            </div>
            <div class="compName">
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.buyerCompName"
                placement="top"
                :disabled="childWidth <= 235"
                popper-class="compToolTipClass"
              >
                <div
                  class="parentClass"
                  @mouseenter="handleMouseEnter($event, index)"
                >
                  <span class="childClass">
                    {{ item.buyerCompName }}
                  </span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getsalesinfo } from '@/utils/api/zhenyun.js'
import {
  homeUrl,
  presentUrl,
  companyLogoUrl,
  previewstatic,
  partDrawingUrl,
} from '@/utils/config.js'
import { getRfq } from '@/utils/api/zhenyun.js'
import {clientContact} from "@/utils/api/zhenyunOrder"
export default {
  head() {
    return {
      title: '海智智造生态伙伴订单专区',
    }
  },
  data() {
    return {
      salesInfoClient: {},
      partDrawingUrl,
      homeUrl: homeUrl,
      presentUrl: presentUrl,
      companyLogoUrl: companyLogoUrl,
      previewstatic: previewstatic,
      loginDialog: false,
      dialogVisible: false,
      defaultRfqThn:
        'https://res.haizol.com/base/images/default_rfq_thumb_56_56.png',
      tabList: [
        {
          name: '国内领先采购数字化平台直链订单',
          id: 1,
        },
      ],
      activeName: 1,
      rfqList: [],
      childWidth: '',
      childTitleWidth: '',
      concatDialogVisible: false,

      authorizationLetter: null, //授权书
      escrowAccount: null, //监管账号
      intermediaryServiceAgreement: null, //居间服务协议
      undertakingLetter: null, //工厂承诺函
      bannerList: [
        {
          text: '甄云科技是国内领先的采购数字化管理平台提供商，已覆盖全球 30+行业、服务1000+知名企业，客户包括中车、中核、中国商飞、美亚光电等数百家制造业领域的中国500强及全球上市企业。',
        },
        {
          text: '上海电气集团数字科技有限公司（简称“电气数科”）是上海电气集团直属子公司。作为上海电气集团数字化转型赋能核心平台，聚焦离散制造行业，依托工业互联网平台及数字孪生技术，提供数字化工厂解决方案。服务全球15+行业、10000+企业用户，客户涵盖国家电网、三菱电梯、上海电气风电集团等500强及上市企业。',
        },
        {
          text: '航天新商务信息科技有限公司（航天新商务）是中国航天科技集团直属的综合电子商务与数字服务公司。其承建和运营的航天电子采购平台是中国航天科技集团统一的数字化采购与供应链服务核心平台，拥有注册供应商20万家，累计发布采购项目超过240万个，覆盖集团单位的采购管理与供应链协同业务。',
        },
        {
          text: '中铁工程装备集团有限公司是世界500强中国中铁旗下核心央企，全球盾构机产销量连续多年位居世界第一，为高端地下工程装备领域龙头企业。公司盾构/TBM年产能280台，累计订单超1800台，产品远销30余个国家和地区，拥有国家级技术中心与全产业链配套能力，产业规模庞大、采购需求稳定，是行业内极具影响力与合作价值的核心企业。',
        },
      ],
    }
  },
  components: {},
  methods: {
    async getContacts() {
      const res = await clientContact(0)
      if (res.rspResult.bizCode == 200) {
        this.salesInfoClient = res.data
      }
    },
    handleClick(val) {
      this.activeName = val.id
    },
    // 立即参与
    joinActive() {
      let url = 'https://ding.cjfx.cn/f/pu1kfkgk'
      window.open(url, '_target')
    },
    //获取用户信息
    getsalesinfoMethod() {
      getsalesinfo().then((res) => {
        const {
          data: { rspResult, data },
        } = res
        if (rspResult.bizCode === 200) {
          this.$store.commit('setsalesinfo', data)
        }
      })
    },
    // 查看全部
    goAllRfq() {
      let url = `${this.presentUrl}/partner/order-radar`
      window.open(url, '_target')
    },
    // 跳转询盘详情
    goRfqDetail(val) {
      let url = `${this.presentUrl}/partner/order-radar/${val.id}`
      window.open(url, '_target')
    },
    handleMouseEnter(event, index) {
      const childClass = document.getElementsByClassName('childClass')
      this.childWidth = childClass[index].scrollWidth

      const childTitleClass = document.getElementsByClassName('childTitleClass')
      this.childTitleWidth = childTitleClass[index].scrollWidth
    },
    // 最新采购需求
    async getRfqList() {
      const res = await getRfq()
      if (res.rspResult.bizCode == 200) {
        this.rfqList = res.rspListData.list
      } else {
        this.$message.error(res.rspResult.message)
      }
    },
  },
  mounted() {
    this.getRfqList()
    this.getContacts()
  },
}
</script>
<style lang="scss" scoped>
.zhenyun {
  &-banner {
    position: relative;
    // width: 100%;
    height: 260px;
    background: url('../../../assets/image/zhenyun/zhenyunBanner.png') center;
    background-size: cover;
    .text {
      position: absolute;
      top: 60px;
      left: 180px;
      font-size: 56px;
      font-weight: 700;
      color: transparent;
      background-clip: text;
      background-image: linear-gradient(180deg, #00259e 13.51%, #222633 90.54%);
    }
    .content {
      width: 626px;
      position: absolute;
      top: 145px;
      left: 180px;
      color: #4b5b76;
      font-size: 16px;
      line-height: 24px;
      font-family: SourceHanSansCN-Medium;
    }
  }
  &-tab {
    background: linear-gradient(to right, #266dff, #003ee7);
    .ul {
      display: flex;
      line-height: 40px;
      width: 1200px;
      height: 40px;
      margin: 0 auto;
      color: #fff;
      li {
        padding: 0 20px;
        cursor: pointer;
      }
      .activeClass {
        background: linear-gradient(to right, #ff7800, #ff4c48);
      }
    }
  }
  &-content {
    padding-bottom: 32px;
    .content-detail {
      background: #fff;
      margin: 0 auto;
      width: 1200px;
      // &-title{
      //    font-weight: 600;
      //    font-size: 24px;
      //    background-image: linear-gradient(180deg, #B44209 -60.29%, #333 98.53%);;
      //    background-clip: text;
      //    color: transparent;
      //    margin-top: 24px;
      //    margin-bottom: 16px;
      // }
      &-msg {
        margin-top: 32px;
        font-size: 16px;
        color: #555555;
        .line {
          display: flex;
          justify-content: space-between;
          position: relative;
          &-mode {
            position: relative;
            // width: 59%;
            width: 696px;
            // padding: 16px 24px;
            border-radius: 24px;
            background: #f9fbff;
            z-index: 10;
            .mode-tag {
              position: absolute;
              top: 0;
              left: 0;
              padding: 3px 16px;
              width: fit-content;
              font-size: 12px;
              font-weight: 700;
              background: linear-gradient(90deg, #fef4db 0%, #fbdca4 100%);
              border-top-left-radius: 8px;
              border-bottom-right-radius: 8px;

              span {
                font-family: SourceHanSansCN-Regular;
                background-image: linear-gradient(to right, #b44209, #333333);
                background-clip: text;
                color: transparent;
              }
            }
            .mode-method {
              color: #222222;
              font-size: 16px;
              p {
                margin: 40px 40px 12px;
                font-family: SourceHanSansCN-Regular;
              }
              .methods {
                display: flex;
                margin-left: 40px;
                .fontclass {
                  font-size: 14px;
                  font-family: SourceHanSansCN-Regular;
                  line-height: 22px;
                }
              }
            }
            .btn {
              display: flex;
              margin-top: 18px;
              position: absolute;
              left: 0;
              bottom: 0;
              box-shadow: 0 4px 8px 0 #002aa129;
              border-radius: 0 0 24px 24px;
              .img {
                position: absolute;
                left: 429px;
                top: 0;
                height: 38px;
                width: 21px;
              }
              .msg {
                color: #406098;
                font-size: 12px;
                line-height: 38px;
                text-align: center;
                background: #e8f2ff;
                // padding: 0 102px;
                width: 450px;
                border-bottom-left-radius: 24px;
                font-family: SourceHanSansCN-Regular;
              }
              .click {
                color: #fff;
                font-size: 14px;
                font-weight: 600;
                background: #2252d9;
                line-height: 38px;
                width: 246px;
                // padding: 0 85px;
                // padding-right: 87px;
                border-bottom-right-radius: 24px;
                font-family: SourceHanSansCN-Regular;
                cursor: pointer;
                text-align: center;
              }
            }
          }
          &-channel {
            // width: 34%;
            background: #fafafa;
            border-radius: 32px;
            padding: 18px;
            line-height: 24px;
            color: #222222;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .down {
              line-height: 28px;
            }
            .up {
              text-align: right;
            }
            .msg {
              padding: 0 10px;
              font-family: SourceHanSansCN-Regular;
              line-height: normal;
            }
          }
        }
      }
    }
    .content-detail2 {
      background: #fff;
      margin: 0 auto;
      width: 1200px;
      border-radius: 32px;
      border: 2px solid #fff2f2;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-top-left-radius: 32px;
        border-top-right-radius: 32px;
        background: linear-gradient(90deg, #fffbef 0%, #fffbf5 100%);
        p {
          font-weight: 600;
          font-size: 24px;
          background-image: linear-gradient(
            180deg,
            #b44209 -60.29%,
            #333 98.53%
          );
          background-clip: text;
          color: transparent;
          font-family: SourceHanSansCN-Regular;
        }
        a {
          color: #555555;
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
        }
      }
      .demand {
        // display: flex;
        // justify-content: space-between;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        column-gap: 24px;
        row-gap: 12px;
        padding: 24px;
        &-item {
          //  width: 24%;
          border: 1px solid #f5f0f0;
          border-radius: 24px;
          text-align: center;
          //  margin-bottom: 12px;

          .product {
            position: relative;
            padding-top: 24px;
            &-icon {
              position: absolute;
              left: 16px;
              top: 16px;
              border-radius: 4px;
              background: #ff081f;
              color: #fff;
              padding: 1px 4px;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              .icon-jinji {
                font-size: 12px;
              }
            }
            &-ul {
              line-height: 28px;
              margin-top: 40px;
            }
            ul li {
              font-family: SourceHanSansCN-Regular;
            }
          }
          img {
            width: 120px;
            height: 120px;
            margin: 0 auto;
          }
          .tag {
            padding: 4px 24px 8px;
            span {
              border-radius: 4px;
              background: #fff2e8;
              color: #ff7800;
              padding: 3px 8px;
              font-family: SourceHanSansCN-Regular;
            }
          }
          .productName {
            .parentTitleClass {
              display: flex;
              max-width: 235px;
              flex-direction: column;
              margin: 0 auto;
            }
            .childTitleClass {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 42px;
              font-family: SourceHanSansCN-Regular;
            }
          }
          .compName {
            font-family: SourceHanSansCN-Regular;
            color: #555;
            margin-top: 8px;
            background: linear-gradient(90deg, #fffcec 0%, #fff 100%);
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            min-height: 42px;
            .parentClass {
              display: flex;
              max-width: 235px;
              flex-direction: column;
              margin: 0 auto;
            }
            .childClass {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 42px;
              font-family: SourceHanSansCN-Regular;
            }
          }
        }
        &-item:hover {
          border: 1px solid #ff7800;
          border-radius: 24px;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep.ecological-zone-dialog-class {
  font-family: SourceHanSansCN-Regular;
  .el-dialog__header {
    padding: 32px 32px 0;
    .header-title {
      color: #222;
      font-weight: 600;
      font-size: 18px;
      .iconfont {
        color: #ff7800;
        margin-right: 6px;
      }
    }
    .el-dialog__headerbtn {
      top: 36px;
      right: 32px;
      .el-dialog__close {
        font-weight: 600;
      }
    }
  }
  ul li {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    .el-icon-close {
      color: #ff081f;
    }
    .el-icon-check {
      color: #20b820;
    }
  }
  .el-dialog__body {
    padding: 32px 32px 24px;
  }
  .dialog-btn {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    .el-button {
      border: 1px solid #0863ff;
      color: #0863ff;
    }
    .el-button:last-child {
      margin: 8px 0;
    }
    .el-button:hover,
    .el-button:focus {
      background-color: transparent;
    }
  }
  .dialog-tip {
    color: #98a3b7;
    font-size: 12px;
    text-align: center;
    margin-top: 4px;
  }
}
.contract-user {
  position: absolute;
  width: 693.5px;
  height: 90px;
  bottom: -2px;
  left: 0;
  border-radius: 0 0 24px 24px;
  border: 1px solid #F0F6FF;
  background: #fcfdff;
  z-index: 1;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: flex-end;
  p {
    margin-top: 55px;
    margin-left: 24px;
    align-self: stretch;
    color: #406098;
    font-family: 'Source Han Sans CN';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
}
:deep(.el-carousel__indicators--horizontal) {
  display: none;
}
</style>
<style lang="scss">
.compToolTipClass {
  max-width: 350px;
}
</style>
